import * as React from 'react';

const { useEffect, useRef } = React;

/**
 * Accepts callback function to execute at specified delay
 */
export const useInterval = (callback, delay) => {
  /*
    1. don't set inerval on each re-render other wise it will lead us to infinite loop
    2. useRef returns mutable current property so we will always point to latest callback
       and mutating current property don't cause re-render
  */
  const savedCallback: React.MutableRefObject<any> = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id); // cleanup function to avoid memory leak
    }
    return;
  }, [delay]);
};
